import { errorHandler } from '../../../util/error.service'
import {
  urlRastreabilidadePalletStatistics,
  urlRastreabilidadePalletTimeline,
} from '../../routes/deliveries.routes'
import { authHttp } from '../http'

export async function getPalletAreaStatistics(tpId, palletAreaId) {
  try {
    const response = await authHttp().get(urlRastreabilidadePalletStatistics(tpId, palletAreaId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getPalletAreaTimeline(palletAreaId) {
  try {
    const response = await authHttp().get(urlRastreabilidadePalletTimeline(palletAreaId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
